<nav  data-aos="bg"
     data-aos-anchor="#trigger"
     data-aos-anchor-placement="top-top">

<div class="navlink">
        <a  class="home" [ngClass]="{red:redHome}"(click)='toHome()'><span  class="l1" i18n="@@span-home-first">H</span><span class="l2" i18n="@@span-home-second">o</span><span i18n="@@span-home-third"class="l3">m</span><span i18n="@@span-home-fourth"class="l4">e</span><img src="assets/images/icons/sys_ico_homepage.svg" alt=""></a>
</div>
<div class="navlink">
        <a class="works" [ngClass]="{red:redWorks}" (click)='toWorks()'><span class="l1" i18n="@@span-works-first">G</span><span class="l2" i18n="@@span-works-second">a</span><span class="l3" i18n="@@span-works-third">l</span><span class="l4" i18n="@@span-works-fourth">l</span><span class="l5" i18n="@@span-works-fifth">e</span><span class="l6" i18n="@@span-works-sixth">r</span><span class="l7" i18n="@@span-works-seventh">y</span><img src="assets/images/icons/sys_ico_design.svg" alt=""></a>
</div>
<div class="navlink">
        <a class="about" [ngClass]="{red:redAbout}"(click)='toAbout()'><span class="l1" i18n="@@span-about-first">A</span><span class="l2" i18n="@@span-about-second">b</span><span class="l3" i18n="@@span-about-third">o</span><span class="l4" i18n="@@span-about-fourth">u</span><span class="l5" i18n="@@span-about-fifth">t</span><img src="assets/images/icons/sys_ico_copy.svg" alt=""></a>
        </div>
<div class="navlink"> 
        <a class="contact" [ngClass]="{red:redContact}" (click)='toContact()'><span class="l1" i18n="@@span-contact-first">C</span><span class="l2" i18n="@@span-contact-second">o</span><span class="l3" i18n="@@span-contact-third">n</span><span class="l4" i18n="@@span-contact-fourth">t</span><span class="l5" i18n="@@span-contact-fifth">a</span><span class="l6" i18n="@@span-contact-sixth">c</span><span class="l7" i18n="@@span-contact-seventh">t</span><img src="assets/images/icons/sys_ico_mail.svg" alt=""></a>
</div>
<!-- <div class="navlink language">
        <a (click)="toggle()"><span class="l1" i18n="@@span-lang-first">L</span><span class="l2" i18n="@@span-lang-second">an</span><span class="l3" i18n="@@span-lang-third">gu</span><span class="l4" i18n="@@span-lang-fourth">ag</span><span class="l5" i18n="@@span-lang-fifth">e </span><span class="l6">
                </span></a>
        <img (click)="toggle()" src="assets/images/icons/sys_ico_fonts.svg" alt="">
        <div class="lang-list" *ngIf="isToggled">
          <div *ngFor="let locale of localesList" class="navlink">
                <a href="/{{locale.code}}/">{{locale.label}}</a>
                </div> -->
        <!-- <a href="http://localhost:4200/home">EN</a>
        <a href="http://localhost:4201/home">FR</a>
        <a href="http://localhost:4202/home">SR</a> -->
        <!-- </div> -->
        
       
<!-- </div> -->

        <!-- <div *ngFor="let locale of localesList" class="navlink">
                <a href="/{{locale.code}}/">{{locale.label}}</a>
        </div> -->

</nav>
<div class="anchor" id='trigger'></div>

